export default function erudaInit() {
    if (
        window.location.href.indexOf('debug=true') > -1 ||
        localStorage.getItem('ccDebugValue') === '1' ||
        localStorage.getItem('ccDebugValue') === 'true'
    ) {
        const src = '//cdn.jsdelivr.net/npm/eruda';
        const scriptLoad = document.createElement('script');
        scriptLoad.src = src;
        scriptLoad.onload = function() {
            window.eruda.init();
        };
        document.body.appendChild(scriptLoad);
    }
}
